import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'dark',

    background: {
      default: '#1e1a20',
      paper: '#2a2430',
    },

    primary: {
      main: '#d14cff',
    },

    text: {
      primary: '#f2e9ff',
      secondary: '#c8b7dd',
    },

    divider: 'rgba(255,255,255,0.12)',

    custom: {
      // ===== Reader =====
      readerBg: '#1e1a20',
      readerHeader: '#d14cff',
      readerTitle: '#ffffff',
      readerDescriptionBg: '#2a2430',
      readerLastUpdateBg: 'rgba(209, 76, 255, 0.08)',
      readerLastUpdateText: '#c8b7dd',
      readerDivide: 'rgba(255,255,255,0.12)',
      readerScrollTrack: 'rgba(255,255,255,0.10)',

      // ===== Modal =====
      modalBackground: '#2a2430',
      modalBorder: '#d14cff',
      modalText: '#f2e9ff',

      // ===== Story Card =====
      storyCardBg: '#2a2430',
      storyCardBorder: 'rgba(255,255,255,0.12)',
      storyCardHeaderText: '#d14cff',

      // ===== Chapters =====
      hoverBg: 'rgba(209, 76, 255, 0.12)',
      chapterTitle: '#f2e9ff',
      chapterSubtitle: '#c8b7dd',

      // ===== Scrollbar =====
      scrollbarTrack: 'rgba(255,255,255,0.10)',
      scrollbarThumb: 'rgba(209, 76, 255, 0.55)',

      // ===== Markdown =====
      markdownText: '#f2e9ff',
      markdownQuoteBorder: 'rgba(209, 76, 255, 0.55)',
      markdownQuoteText: '#c8b7dd',
    },
  },
});